import React, {lazy, Suspense} from 'react'

const DiscernmentLazy = lazy(() =>
    import('./Discernment')
)

const Discernment = props => (
    <Suspense fallback={null}>
        <DiscernmentLazy {...props} />
    </Suspense>
)

export default Discernment
